import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Personalize from "@/pages/Personalize";
import Suggestions from "@/pages/Suggestions";
import Player from "@/pages/Player";
import ParentBaby from "@/pages/ParentBaby";
import BabyAmbient from "@/pages/BabyAmbient";
import Music from "@/pages/Music";
import Favorites from "@/pages/Favorites";
import Methods from "@/pages/Methods";
import Settings from "@/pages/Settings";
import AuthPage from "@/pages/Auth";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Discovery from "@/pages/Discovery";
import MonEspace from "@/pages/MonEspace";
import { initTts } from "@/lib/tts";
import { startScheduler, stopScheduler, getReminderConfig } from "@/lib/reminders";
import { AuthProvider, useAuth } from "@/lib/auth";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-10 text-center text-[color:var(--ivoire-muted)]">…</div>;
  if (!user) return <Navigate to="/connexion" replace state={{ from: loc.pathname }} />;
  return children;
}

function App() {
  useEffect(() => {
    initTts();
    if (getReminderConfig().enabled) startScheduler();
    return () => stopScheduler();
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/personnaliser" element={<Personalize />} />
              <Route path="/suggestions" element={<Suggestions />} />
              <Route path="/bebe" element={<ParentBaby />} />
              <Route path="/bebe/ambiance" element={<BabyAmbient />} />
              <Route path="/musique" element={<Music />} />
              <Route path="/favoris" element={<Favorites />} />
              <Route path="/methodes" element={<Methods />} />
              <Route path="/reglages" element={<Settings />} />
              <Route path="/premium" element={<Premium />} />
              <Route path="/connexion" element={<AuthPage mode="login" />} />
              <Route path="/inscription" element={<AuthPage mode="register" />} />
              <Route path="/decouverte" element={<Discovery />} />
              <Route path="/mon-espace" element={<Protected><MonEspace /></Protected>} />
              <Route path="/paiement/succes" element={<Protected><PaymentSuccess /></Protected>} />
              <Route path="/paiement/annule" element={<PaymentCancel />} />
            </Route>
            <Route path="/lecteur/:id" element={<Player />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#142235",
              color: "#F7F4EA",
              border: "1px solid rgba(136,160,150,0.25)",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
